import styled from 'styled-components';
import { InternalLink } from '../../components/navigation/internal-link';
import { getBouLinkStyle } from './bou-link';

export const inlineLinkStyle = getBouLinkStyle(true);
export const InternalInlineLink = styled(InternalLink)`
  ${inlineLinkStyle}
`;
export const StyledExternalInlineLink = styled.a`
  ${inlineLinkStyle}
`;
